import SingleStepNotification from './single-step-notification'

export default class StepDelayNotification extends SingleStepNotification {
  constructor(transfer, filter) {
    super(transfer, filter)
    this.name = 'StepDelay'
    this.delayThresholdMinutes = null
    this.filterEventId = 'STEP_DELAY_EXPECTED'

    if (filter) {
      this.channelName = this.filter.channelName
      this.delayThresholdMinutes = this.filter.predicateConfigs[0].greaterThan.smaller.timedelta.minutes

      const signature = this.filter.signature
      this.attachedStepId = signature ? signature.stepId : null
    }
  }

  get predicateConfigs() {
    return [
      {
        greaterThan: {
          bigger: {
            timedelta: {
              seconds: '@delayTimedelta'
            }
          },
          smaller: {
            timedelta: {
              minutes: parseInt(this.delayThresholdMinutes, 10)
            }
          }
        }
      },
      {
        lessThan: {
          bigger: {
            timedelta: {
              days: 1
            }
          },
          smaller: {
            timedelta: {
              seconds: '@delayTimedelta'
            }
          }
        }
      }
    ]
  }

  get summaryText() {
    const stepName = this.formatConfigurable(this.attachedStep.name)
    const delay = this.formatConfigurable(this.delayThresholdMinutes)
    const channel = this.formatConfigurable(this.friendlyChannelName)
    return `If the ${stepName} is delayed by more than ${delay} minutes, inform me via ${channel}.`
  }

  get message() {
    if (this.channelName === 'TWILIO_CALL')
      return '<Response><Say voice="alice" language="en-US"><Pause length="3"/>Hello, this is the automatic sennder call service. The {{ stepName }} in the transfer {{ transferName }} is delayed or expected to be delayed by {{ delayTimedelta | divideby: "60" }} minutes. Thank you for working with us. Your sender team.</Say></Response>'
    return 'This is an automatic sennder system notification for the transfer {{ transfer_name }}. The {{ step_name }} is delayed or expected to be delayed by {{ delay_timedelta  | divideby: "60" }} minutes.'
  }
}
